const metadataScriptTag = document.getElementById('metadata');
const metadata = JSON.parse(metadataScriptTag?.innerText ?? '').metadata;
export default metadata;
